// extracted by mini-css-extract-plugin
module.exports = {"image":"MediaImage_image__M0sFB"};